import { render, staticRenderFns } from "./search-duration-slider.vue?vue&type=template&id=52383a8e"
import script from "./search-duration-slider.vue?vue&type=script&lang=js"
export * from "./search-duration-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports